<label class="input-group" [ngClass]="[verticalSpace ? verticalSpace : '', horizontalSpace ? horizontalSpace : '']">
  <typography-legacy text-small-semibold class="primary-text mb-xs">{{ label }}</typography-legacy>
  <div class="input-field" [ngClass]="{ focused: isFocused }">
    <ng-content select="input"></ng-content>
  </div>
  <div [@enterAnimation]="inputError ? 'show' : 'hide'" class="error">{{ inputErrorText }}</div>
  <div *ngIf="hint" class="hint">{{ inputHintText }}</div>
</label>
